import { useContext } from 'react';
import { TourContext } from './tour.context';

export const useTour = () => {
  const ctx = useContext(TourContext);

  if (!ctx) {
    throw new Error('useTour должен быть внутри TourProvider');
  }

  return ctx;
};
